// @flow
import React from "react";
import styled, { keyframes, css } from "styled-components";
import type { ComponentType } from "react";
import consts from "common/consts";

const ANIMATION_DURATION = "0.2s";

const animationKeyframes = keyframes`
    0% {
        margin-left: -230px;
    }

    100% {
        margin-left: 0;
    }
`;

const animation = css`
    animation: ${ANIMATION_DURATION} ${animationKeyframes} linear forwards;
`;

const Wrapper: ComponentType<{openSidePanel: boolean}> = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    overflow: hidden;

    // side panel
    > :first-child {
        height: 100%;
        width: 230px;
        margin-left: -230px;
        will-change: margin-left;
        z-index: 4;
        flex-shrink: 0;
        position:relative;
        ${({ openSidePanel }) => openSidePanel && animation};

         @media (max-width: 767px) {
            width: 340px;
            margin-left: -340px;

            &:after {
                content: '';
                width: 100vw;
                height: 100vh;
                z-index: 0;
                top: ${consts.TAB_HEADER_HEIGHT}px;
                left: 100%;
                background: #323A45;
                opacity: 0.9;
                position: absolute;
                display: ${({ openSidePanel }) => (openSidePanel ? "block" : "none")};
            }
         }

         > div {
            box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
            overflow-x: hidden;
            user-select: none;

            .panel-header-container {
            height: ${consts.TAB_HEADER_HEIGHT}px;
            padding: 0 10px;
            display: flex;
            align-items: center;
            }
         }
    }

    // tab content
    > :nth-child(2) {
        min-width: 0;
        width: ${({ openSidePanel }) => (openSidePanel ? "calc(100% - 230px)" : "100%")} !important;
        will-change: width;
        flex: 1 1 100%;
        transition: width ${ANIMATION_DURATION} linear;

         @media (max-width: 767px) {
            flex: 1 0 100%;
            width: 100%;
        }
    }
`;

type Props = {
    openSidePanel: boolean,
    children: Object,
    // todo: using any because ComponentType<any> doesnt work... :(
    sidePanel: any
};

const WithSidePanel = ({ openSidePanel = false, sidePanel: SidePanel, children }: Props) => (
	<Wrapper openSidePanel={openSidePanel} >
		<div>
			{SidePanel && <SidePanel/>}
		</div>
		{children}
	</Wrapper>
);

export default WithSidePanel;
